'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { clickEvent, BumpableItemPreCheckoutModel } from '@marketplace-web/vas/vas-data'

import { ItemPageBumpActionModel } from '../types'
import useStartBumpCheckout from '../../../../hooks/useStartBumpCheckout'
import BumpCheckout from '../../../../components/Bumps/BumpCheckout/BumpCheckout'

type Props = {
  item: ItemPageBumpActionModel
}

const ItemBumpButton = ({ item }: Props) => {
  const { track } = useTracking()
  const translate = useTranslate('item.actions')
  const { startCheckout } = useStartBumpCheckout()

  function isPromoteButtonVisible() {
    const isButtonDisabled = item?.isPromoted || !item.canPushUp

    if (item?.isClosed || item?.isReserved) return false

    return !isButtonDisabled
  }

  function getBumpableItemDataFromItemActionModel(
    itemModel: ItemPageBumpActionModel,
  ): BumpableItemPreCheckoutModel {
    return {
      id: itemModel.id,
      title: itemModel.title,
      thumbnail: itemModel.thumbnail,
    }
  }

  function handleOnClick() {
    startCheckout(getBumpableItemDataFromItemActionModel(item))

    track(
      clickEvent({
        target: 'push_up_item',
        targetDetails: JSON.stringify({
          item_id: item.id,
        }),
        screen: 'item',
      }),
    )
  }

  return (
    <>
      {isPromoteButtonVisible() && (
        <Button
          text={translate('bump')}
          size={Button.Size.Medium}
          styling={Button.Styling.Filled}
          onClick={handleOnClick}
          testId="item-bump-button"
        />
      )}
      <BumpCheckout />
    </>
  )
}

export default ItemBumpButton
